import { Outlet, ScrollRestoration } from "react-router-dom";

function EmptyPage() {


    return(
        <>
            <Outlet />
            <ScrollRestoration />
        </>
    )
}

export default EmptyPage;